import Image from 'react-bootstrap/Image';
import classes from './Logo.module.scss';
import LogoImg from '../../images/logo.png'

const Logo = (props) => {
    return <Image className={classes.logo} variant='top' src={LogoImg} />
}

export default Logo;